import {globalColorsNBD} from '@volkswagen-onehub/tokens'

export const ULTRAMARINE_EYE_CATCHER_BACKGROUND =
    globalColorsNBD.ultramarine['90']

export const PURPLE_EYE_CATCHER_BACKGROUND = globalColorsNBD.purple['70']
